import { MoovStepInstanceDTO } from "../DTO/moovStepInstanceDTO";
import { MetadataValue } from "./metadataValue";
import { MoovFile } from "./moovFile";
import { MoovStepConfiguration } from "./moovStepConfiguration";
import { MoovStepSchedule } from "./moovStepSchedule";

export class MoovStepInstance{
    public id!: number;
    public moovStepConfiguration!: MoovStepConfiguration;
    public inputFile!: MoovFile;
    public outputFile!: MoovFile;
    public logFile?: MoovFile;
    public outputParameterValues!: OutputParameterValue[];
    public startedExecutionAt!: Date;
    public finishedExecutionAt!: Date;
    public undoInProcess!: boolean;
    public undoError!: boolean;
    public undoMessage!: string;
    public undoneAt!: Date;
    public approved!: Date;
    public approvedByUserId!: number;
    public suspended!: boolean;
    public success:boolean = false;
    public permanentError!: boolean;
    public errors!: string;
    public approvalId!: string;
    public skipped!: boolean;
    public moovStepSchedule!: MoovStepSchedule;
    public remarks!: string;
    public purgeOutputParameterValuesAfter!: Date;
    public purgedOutputParameterValuesAt!: Date;

    public formattedRemarks!: string;

    public static mapFromDTO(param:MoovStepInstanceDTO):MoovStepInstance{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovStepInstance();
        try
        {
            obj.id = param.id;
            obj.moovStepConfiguration = MoovStepConfiguration.mapFromDTO(param.moovStepConfiguration);
            obj.inputFile = MoovFile.mapFromDTO(param.inputFile);
            if(param.outputFile) obj.outputFile = MoovFile.mapFromDTO(param.outputFile);
            if(param.logFile) obj.logFile = MoovFile.mapFromDTO(param.logFile);
            if(param.outputParameterValues) obj.outputParameterValues = JSON.parse(param.outputParameterValues);
            if(param.startedExecutionAt) obj.startedExecutionAt = new Date(param.startedExecutionAt);
            if(param.finishedExecutionAt) obj.finishedExecutionAt = new Date(param.finishedExecutionAt);
            obj.undoInProcess = param.undoInProcess;
            obj.undoError = param.undoError;
            obj.undoMessage = param.undoMessage;
            if(param.undoneAt) obj.undoneAt = new Date(param.undoneAt);
            if(param.approved) obj.approved = new Date(param.approved);
            if(param.approvedByUserId) obj.approvedByUserId = param.approvedByUserId;
            obj.suspended = param.suspended;
            obj.success = param.success;
            obj.permanentError = param.permanentError;
            if(param.errors) obj.errors = param.errors;
            obj.approvalId = param.approvalId;
            obj.skipped = param.skipped;
            if(param.moovStepSchedule) obj.moovStepSchedule = MoovStepSchedule.mapFromDTO(param.moovStepSchedule);
            obj.remarks = param.remarks;
            obj.formattedRemarks=obj.remarks?.replace(/<i>/g,"").replace(/<\/i>/g,"").replace(/<b>/g,"").replace(/<\/b>/g,"").split('</br>').join('\n');
            if(param.purgeOutputParameterValuesAfter) obj.purgeOutputParameterValuesAfter = new Date(param.purgeOutputParameterValuesAfter);
            if(param.purgedOutputParameterValuesAt) obj.purgedOutputParameterValuesAt = new Date(param.purgedOutputParameterValuesAt);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovStepInstance):MoovStepInstanceDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovStepInstanceDTO();
        try
        {
            dto.id = param.id;
            dto.moovStepConfiguration = MoovStepConfiguration.mapToDTO(param.moovStepConfiguration);
            dto.inputFile = MoovFile.mapToDTO(param.inputFile);
            if(param.outputFile) dto.outputFile = MoovFile.mapToDTO(param.outputFile);
            if(param.logFile) dto.logFile = MoovFile.mapToDTO(param.logFile);
            if(param.outputParameterValues) dto.outputParameterValues = JSON.stringify(param.outputParameterValues);
            if(param.startedExecutionAt) dto.startedExecutionAt = param.startedExecutionAt.toISOString();
            if(param.finishedExecutionAt) dto.finishedExecutionAt = param.finishedExecutionAt.toISOString();
            dto.undoInProcess = param.undoInProcess;
            dto.undoError = param.undoError;
            dto.undoMessage = param.undoMessage;
            if(param.undoneAt) dto.undoneAt = param.undoneAt.toISOString();
            if(param.approved) dto.approved = param.approved.toISOString();
            if(param.approvedByUserId) dto.approvedByUserId = param.approvedByUserId;
            dto.suspended = param.suspended;
            dto.success = param.success;
            dto.permanentError = param.permanentError;
            if(param.errors) dto.errors = param.errors;
            dto.approvalId = param.approvalId;
            dto.skipped = param.skipped;
            if(param.moovStepSchedule) dto.moovStepSchedule = MoovStepSchedule.mapToDTO(param.moovStepSchedule);
            dto.remarks = param.remarks;
            if(param.purgeOutputParameterValuesAfter) dto.purgeOutputParameterValuesAfter = param.purgeOutputParameterValuesAfter.toISOString();
            if(param.purgedOutputParameterValuesAt) dto.purgedOutputParameterValuesAt = param.purgedOutputParameterValuesAt.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
    
    get displayStatus(){
        if(!this.finishedExecutionAt && this.moovStepSchedule && this.moovStepSchedule.executeOnOrAfter) return "pending"
        if(!this.finishedExecutionAt && this.approvedByUserId>0 && !this.approved) return "pending approval"
        if(this.finishedExecutionAt && this.success && !this.skipped) return "completed";
        if(this.finishedExecutionAt && this.success && this.skipped) return "completed (skipped)";
        if(this.finishedExecutionAt && !this.success) return "failed";
        if(this.moovStepSchedule && this.moovStepSchedule.inProgress) return "processing";
        else return "created";
    }

    get statusColor(){
        if(!this.finishedExecutionAt && this.moovStepSchedule && this.moovStepSchedule.executeOnOrAfter) return "blue";
        if(this.finishedExecutionAt && !this.success) return "red";
        return "black";
    }

    get canRushExecution(){
        return (!this.startedExecutionAt && !this.finishedExecutionAt && !this.suspended && this.moovStepSchedule && this.moovStepSchedule.canRushExecution);
    }

    get canRunFailedExecution(){
        return (this.startedExecutionAt && this.finishedExecutionAt && !this.success && !this.permanentError);
    }

}

export class OutputParameterValue{
    public name!: string;
    public stepType!: string;
    public value!: any;
    public metadataValue!: MetadataValue;
}